import React from 'react';
import { useTranslation } from "react-i18next";

interface IInclusionType {
    value: string;
    key: string;
}

const InclusionType = (props: IInclusionType) => {
    const { t } = useTranslation();

    return <span key={`${props.key}-type`}>
        {t(`taxes.columns.${props.value}`)}
    </span>;
}

export default InclusionType;